<template>
  <div v-if="renderReady && !model.$disabled">
    <w-label
      :model="model"
      :title="title"
      :show-label="showLabel"
      :description="description"
      :next-number="nextNumber"
      :bold-label="boldLabel"
      :labelFor="setId"
      :only-description="onlyDescription"
      :autotext="autotext"
    >
      <template v-slot:prepend>
        <slot name="prependlabel" />
      </template>

      <template v-slot:description>
        <slot name="description" />
      </template>

      <template v-slot:append>
        <slot name="appendlabel" />
      </template>
    </w-label>

    <div :class="{'state-error': model.$error, 'state-disabled': isDisabled && !borderless}" class="input">
      <component
        :is="prependicon && prependicon.startsWith('fa-') ? 'i' : 'span'"
        class="icon-prepend fa"
        v-if="prependicon || $slots.prependicon"
        :class="prependicon && prependicon.startsWith('fa-') ? prependicon : ''"
      >
        <slot name="prependicon" class="icon-prepend">{{ prependicon.startsWith('fa-') ? '' : prependicon }} </slot>
      </component>

      <input
        :id="setId"
        ref="input"
        :type="iType"
        :placeholder="getPlaceholder"
        :class="['form-control', {borderless: borderless, 'text-right': textRight, 'has-append': appendicon || $slots.appendicon}, css]"
        :style="appendiconTextRight"
        :disabled="isDisabled"
        :value="svalue"
        :name="model.$form.testPath ? model.$path : undefined"
        :aria-invalid="isError"
        :aria-label="activeAria"
        :aria-describedby="showError && isError ? dataIds.errId : undefined"
        :aria-labelledby="checkLabelledby({maxLength: {lengthId, isMaxLength}, labelledbyId})"
        @input="onInput($event)"
        @focus="onFocus($event)"
        @blur="onBlur($event)"
        @mouseover="mouseOver($event)"
        @mouseleave="mouseOut($event)"
      />

      <component
        :is="appendicon && appendicon.startsWith('fa-') ? 'i' : 'span'"
        class="icon-append fa"
        v-if="appendicon || $slots.appendicon"
        :class="appendicon && appendicon.startsWith('fa-') ? appendicon : ''"
      >
        <slot name="appendicon" class="icon-append">{{ appendicon.startsWith('fa-') ? '' : appendicon }}</slot>
      </component>
    </div>

    <div v-if="isMaxLength" class="text-note text-muted">
      <small :class="{'text-danger': textLength > model.$schema.maxLength}" :id="lengthId">{{ textLength }} z {{ model.$schema.maxLength || 0 }}</small>
    </div>

    <w-error v-if="showError" :model="model" :id="dataIds.errId" @focus="$refs.input.focus()" />

    <w-warning v-if="showWarning && !(showError && model.$error)" :model="model" :id="setId" @focus="$refs.input.focus()" />
  </div>
</template>

<script>
import titleMixin from '../mixins/titleMixin';
import modelMixin from '../mixins/modelMixin';
import WError from './error.vue';
import WWarning from './warning.vue';
import WTooltip from './tooltip.vue';

export default {
  name: 'w-input',
  components: {WError, WWarning, WTooltip},
  props: {
    placeholder: String,
    appendicon: {
      type: String,
      default: ''
    },
    prependicon: {
      type: String,
      default: ''
    },
    setTitleAsPlaceholder: {
      type: Boolean,
      default: false
    },
    showWarning: {
      type: [Boolean, String],
      default: false
    },
    iType: {
      type: String,
      default: 'text'
    },
    css: [Object, String, Array]
  },
  mixins: [modelMixin, titleMixin],
  data() {
    return {
      placeHolder: ''
    };
  },
  computed: {
    textRight() {
      return this.model.$schema.type === 'number' || this.model.$schema.type === 'money' || this.model.$schema.type === 'integer';
    },
    appendiconTextRight() {
      return this.textRight && this.appendicon ? {paddingRight: '35px!important'} : {};
    },
    getPlaceholder() {
      this.placeHolder = this.placeholder;
      if (this.setTitleAsPlaceholder) {
        this.placeHolder = this.getTitle;
        return this.placeHolder;
      } else {
        return this.placeHolder;
      }
    },
    textLength() {
      if (!this.model.$model) {
        return 0;
      }

      return this.model.$model.length;
    }
  },
  methods: {}
};
</script>

<style>
.icon-prepend .checkbox,
.icon-append .checkbox {
  left: 1px !important;
  position: relative !important;
  top: -2px !important;
}
.smart-form .input input.has-append {
  padding-right: 37px !important;
}
.noborderdisabled td.input .icon-prepend label.checkbox,
.noborderdisabled td.input .icon-appendicon label.checkbox {
  margin-top: auto;
  margin-left: auto;
}
</style>
